import React, { useEffect, useState, useCallback } from "react";
import styles from "./Stadistics.module.css";
import { useDispatch } from "react-redux";
import userDefault from "../../../assets/iconUser.png";
import { getUser } from "../../../actions";
import Escudo from "./Componentes/Escudo";
import Equipo from "./Componentes/Equipo";
import Verificadas from "./Componentes/Verificadas";
import ModalMetrica from "./Modales/ModalMetrica/ModalMetrica";
import ModalEntrenamiento from "./Modales/ModalEntrenamiento/Modalentrenamiento";

// Componente principal que muestra las estadísticas del usuario
export default function Stadistics({ entrenamientos, setShowNavSecond, isMobile }) {
  const dispatch = useDispatch();

  // Datos del usuario desde localStorage
  const detailUser = JSON.parse(localStorage.getItem("dataUser"));

  // Estados
  const [currentDate, setCurrentDate] = useState(new Date());
  const [rachaActual, setRachaActual] = useState(0);
  const [metricaBool, setMetricaBool] = useState(false);
  const [metricaValor, setMetricaValor] = useState("");
  const [modalEntrenamientoBool, setModalEntrenamientoBool] = useState(false);

  // Calcula días consecutivos de entrenamiento
  function getRachaActual() {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const sortedEntrenamientos = entrenamientos
      .map((ent) => ({
        ...ent,
        normalizedDate: new Date(new Date(ent.createdAt).setHours(0, 0, 0, 0)),
      }))
      .sort((a, b) => b.normalizedDate - a.normalizedDate);
    let streak = 0;
    let currentDate = today;
    for (const ent of sortedEntrenamientos) {
      if (ent.normalizedDate.getTime() === currentDate.getTime()) {
        streak++;
        currentDate.setDate(currentDate.getDate() - 1);
      } else if (ent.normalizedDate < currentDate) {
        break;
      }
    }
    setRachaActual(streak);
  }

  // Efectos
  useEffect(() => {
    getRachaActual();
  }, [entrenamientos]);

  useEffect(() => {
    dispatch(getUser(detailUser.id));
  }, [dispatch, detailUser.id]);

  // Manejador para abrir modal de entrenamiento
  const handlerClickEntrenamiento = () => {
    setModalEntrenamientoBool(true);
    window.scrollTo(0, 0);
    if (isMobile) setShowNavSecond(false);
  };

  const metricaClick = useCallback((metricaV) => {
    setMetricaBool(true);
    setMetricaValor(metricaV);
    window.scrollTo(0, 0);
    if (isMobile) setShowNavSecond(false);
  }, [setShowNavSecond]);

  return (
    <div className={styles.conteiner}>
      <Escudo detailUser={detailUser} userDefault={userDefault} />
      <div className={styles.equipo}>
        <Equipo
          entrenamientos={entrenamientos}
          handlerClickEntrenamiento={handlerClickEntrenamiento}
          currentDate={currentDate}
          rachaActual={rachaActual}
        />
        <Verificadas
          detailUser={detailUser}
          metricaClick={metricaClick}
        />
      </div>
      {metricaBool && (
        <ModalMetrica
          setMetricaBool={setMetricaBool}
          metricaV={metricaValor}
          user={detailUser}
          setShowNavSecond={setShowNavSecond}
          isMobile={isMobile}
        />
      )}

      {modalEntrenamientoBool && (
        <ModalEntrenamiento
          entrenamientos={entrenamientos}
          setModalEntrenamientoBool={setModalEntrenamientoBool}
          user={detailUser}
          setShowNavSecond={setShowNavSecond}
          isMobile={isMobile}
        />
      )}
    </div>
  );
}
